import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  details: 0,
};

const getters = {};

const actions = {
  async getDetails({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.InstagramMedia}?instaMediaId=${data.id}`
    );
  },
  async getDetailsAgendada({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.InstagramMediaSchedule}?data_inicio=${data.date.start}&id=${data.id}`
    );
  },
  async getComentsDetails({ commit }, data) {
    const formata = window.location.pathname.substring(9);
    return await API.get(
      `${environment.apiUri}${route.InstagramComments}?instaMediaId=${formata}`
    );
  },
  async PostComents({ commit }, data) {
    return await API.post(
      `${environment.apiUri}${route.ReplyComment}?commentId=${data.commentId}&text=${data.text}`
    );
  },
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
